<template>
  <!-- system 标准列表：对齐 police-record/index.vue -->
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="handleCreate">新建申请</el-button>
      </template>
      <template slot="applyNo" slot-scope="{ row }">
        <el-link type="primary" @click="openDetail(row)">{{ row.applyNo || '-' }}</el-link>
      </template>
      <template slot="workOrderNo" slot-scope="{ row }">
        <el-link type="primary" @click="handleWorkOrderClick(row)">{{ row.workOrderNo || '-' }}</el-link>
      </template>
      <template slot="appliedParts" slot-scope="{ row }">
        <span>{{ formatAppliedParts(row.list) }}</span>
      </template>
      <template slot="applyStatus" slot-scope="{ row }">
        <el-tag :type="getStatusTagType(row.applyStatus)" size="mini">
          {{ getStatusLabel(row.applyStatus) }}
        </el-tag>
      </template>
      <template slot="menu" slot-scope="{ row, index }">
        <template v-if="row.applyStatus === 1">
          <el-button type="text" size="small" style="color: #67c23a" @click="handleApprove(row)">通过</el-button>
          <el-button type="text" size="small" style="color: #f56c6c" @click="handleReject(row)">拒绝</el-button>
          <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
        </template>
        <template v-else-if="row.applyStatus === 2">
          <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
        </template>
        <template v-else-if="row.applyStatus === 3">
          <el-button type="text" size="small" @click="openDetail(row)">详情</el-button>
          <el-button type="text" size="small" style="color: #909399" @click="handleReReview(row)">重新审核</el-button>
        </template>
      </template>
    </avue-crud>

    <application-detail-dialog
      :visible.sync="detailVisible"
      :detail="detailData"
      :loading="detailLoading"
      @approve="handleApproveFromDetail"
      @reject="handleRejectFromDetail"
      @re-review="handleReReviewFromDetail"
    />
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, getDetail, approve, reject, reReview } from "./api";
import { APPROVAL_STATUS_DICT } from "./const";
import ApplicationDetailDialog from "./components/ApplicationDetailDialog.vue";

export default {
  name: "parts-application-record",
  mixins: [crudMixins],
  components: { ApplicationDetailDialog },
  data() {
    return {
      apiConfig: { getList },
      detailVisible: false,
      detailLoading: false,
      detailData: {},
      option: {
        ...this.$store.state.publicOption,
        menu: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        stripe: true,
        menuWidth: 200,
        column: [
          {
            label: "时间范围",
            prop: "timeRange",
            type: "daterange",
            format: "yyyy-MM-dd",
            valueFormat: "yyyy-MM-dd",
            search: true,
            hide: true,
            span: 8,
            searchSpan: 6,
            paramsKey: ["startTime", "endTime"],
          },
          {
            label: "审核状态",
            prop: "applyStatus",
            search: true,
            hide: true,
            type: "select",
            span: 8,
            dicData: [
              { label: "全部", value: "" },
              ...APPROVAL_STATUS_DICT,
            ],
          },
          {
            label: "工单编号",
            prop: "workOrderNo",
            search: true,
            hide: true,
            span: 8,
            placeholder: "输入工单编号",
          },
          // 表格列
          {
            label: "申请单号",
            prop: "applyNo",
            slot: true,
            minWidth: 160,
            fixed: "left",
          },
          {
            label: "申请时间",
            prop: "applyTime",
            minWidth: 160,
          },
          {
            label: "工单编号",
            prop: "workOrderNo",
            slot: true,
            minWidth: 140,
          },
          {
            label: "维修人员",
            prop: "applyUserName",
            minWidth: 150,
            formatter: (row) => {
              return row.applyUserName || "-";
            },
          },
          {
            label: "申请配件",
            prop: "appliedParts",
            slot: true,
            minWidth: 250,
          },
          {
            label: "审核状态",
            prop: "applyStatus",
            slot: true,
            minWidth: 100,
          },
        ],
      },
    };
  },
  methods: {
    formatAppliedParts(parts) {
      if (!parts) return "-";
      if (Array.isArray(parts)) {
        return parts.map(p => {
          const name = p.partName || "";
          const qty = p.applyCount || 0;
          return qty > 0 ? `${name}×${qty}` : name;
        }).join(", ") || "-";
      }
      if (typeof parts === "string") {
        return parts;
      }
      return "-";
    },
    getStatusTagType(status) {
      const map = {
        1: "warning",  // 待审核
        2: "success",  // 已通过
        3: "danger",   // 已拒绝
      };
      return map[status] || "";
    },
    getStatusLabel(status) {
      const item = APPROVAL_STATUS_DICT.find(d => d.value === status);
      return item ? item.label : status || "-";
    },
    async openDetail(row) {
      if (!row.id) {
        this.$message.warning("未找到记录ID");
        return;
      }
      this.detailVisible = true;
      this.detailLoading = true;
      try {
        const res = await getDetail(row.id);
        this.detailData = (res.data && res.data.data) || {};
      } catch (e) {
        this.detailData = {};
        this.$message.error("获取详情失败");
      } finally {
        this.detailLoading = false;
      }
    },
    handleCreate() {
      this.$message.info("新建申请功能待开发");
    },
    handleWorkOrderClick(row) {
      this.$message.info(`工单编号: ${row.workOrderNo || "-"}`);
    },
    async handleApprove(row) {
      try {
        await this.$confirm("确认通过该申请？", "提示", {
          type: "warning",
        });
        await approve(row.id, { remark: "审核通过" });
        this.$message.success("操作成功");
        this.onLoad(this.page);
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error("操作失败");
        }
      }
    },
    async handleReject(row) {
      try {
        const { value } = await this.$prompt("请输入拒绝原因", "拒绝申请", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputType: "textarea",
        });
        await reject(row.id, { remark: value || "拒绝申请" });
        this.$message.success("操作成功");
        this.onLoad(this.page);
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error("操作失败");
        }
      }
    },
    async handleReReview(row) {
      try {
        await this.$confirm("确认重新审核该申请？", "提示", {
          type: "warning",
        });
        await reReview(row.id);
        this.$message.success("操作成功");
        this.onLoad(this.page);
      } catch (e) {
        if (e !== "cancel") {
          this.$message.error("操作失败");
        }
      }
    },
    handleApproveFromDetail() {
      this.onLoad(this.page);
      this.detailVisible = false;
    },
    handleRejectFromDetail() {
      this.onLoad(this.page);
      this.detailVisible = false;
    },
    handleReReviewFromDetail() {
      this.onLoad(this.page);
      this.detailVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
</style>



